module.exports = __webpack_public_path__ + "img/icon-retirement.1c82c03e.svg";